import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {Project} from '../../project';
import {Warehouse} from '../../warehouse';

/**
 * Created by cate on 03-07-17.
 */

@Component({
    selector: 'app-project-data-form',
    templateUrl: './project-data-form.component.html',
    styleUrls: ['../project-form.css']
})
export class ProjectDataFormComponent implements OnInit {
    _project: Project;
    projectData: AbstractControl;
    warehouseTypes = Warehouse.getWarehouseTypes();
    confirmWarehouseType: number;

    @ViewChild('modalBtn') private changeWarehouseTypeModal: ElementRef;
    @ViewChild('modalCloseBtn') private changeWarehouseTypeCloseModal: ElementRef;

    @Input() projects: Project[];

    @Input()
    set project(p: Project) {
        this._project = p;
        this.projectData.reset({
            name: this._project.name,
            client: this._project.client,
            location: this._project.location,
            warehouse_type: this._project.warehouse_type,
            contact: this._project.contact,
            phone: this._project.phone,
            email: this._project.email
        });
    }

    validationMessages = {
        'name': {
            'required': 'Ingresar un nombre.',
            'unique': 'Este nombre ya existe',
            'maxlength': 'El nombre excede el número máximo de carácteres'
        },
        'client': {
            'required': 'Ingresar un cliente.'
        },
        'location': {
            'required': 'Ingresar una ubicación.'
        },
        'warehouse_type': {
            'required': 'Seleccionar un tipo de galpón.',
            'pattern': 'Seleccionar un tipo válido de galpón'
        },
        'email': {
            'email': 'Ingresar un email válido'
        }
    };

    formErrors = {
        'name': '',
        'client': '',
        'location': '',
        'warehouse_type': '',
        'email': ''
    };

    constructor(private _fb: FormBuilder) {
        this.projectData = this._fb.group({
            name: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(253)]],
            client: ['', []],
            location: ['', []],
            warehouse_type: [null, [Validators.required]],
            contact: ['', []],
            phone: ['', []],
            email: ['', [Validators.email]]
        });
    }

    ngOnInit(): void {
        this.projectData.valueChanges.subscribe(values => this.onValueChanged());
        if (this._project.name === '') {
            this.formErrors['name'] = this.validationMessages['name']['required'];
        }
    }

    private onValueChanged() {
      if (this._project.warehouse && this._project.warehouse.type !== this.projectData.value.warehouse_type) {
        this.confirmWarehouseType = this.projectData.value.warehouse_type;
        this.changeWarehouseTypeModal.nativeElement.click();
      }
      const form = this.projectData;
      this.updateProject();
      Object.keys(this.formErrors).forEach(field => {
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control.dirty && !control.valid) {
          console.log(this.validationMessages[field], field);
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            console.log('key', key)
            if (control.errors.hasOwnProperty(key)) {
              console.log('control.errors.hasOwnProperty(', key, messages[key]);
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      });

      this.checkUniqueName(this.projectData.value.name);
    }

    updateProject() {
        this._project.name = this.projectData.value.name;
        this._project.client = this.projectData.value.client;
        this._project.location = this.projectData.value.location;
        this._project.contact = this.projectData.value.contact;
        this._project.phone = this.projectData.value.phone;
        this._project.email = this.projectData.value.email;
        this._project.warehouse_type = this.projectData.value.warehouse_type;
    }

    initWarehouse(type) {
      this.projectData.patchValue({warehouse_type: type});
      this._project.warehouse = Warehouse.getWarehouseByType(this._project.warehouse_type);
    }

    changeWarehouseType() {
      this.initWarehouse(this.confirmWarehouseType);
      this.changeWarehouseTypeCloseModal.nativeElement.click();
    }

    checkUniqueName(name) {
        if (this.projects) {
            this.projects.forEach(project => {
                if (this._project.id !== project.id && project.name === name) {
                    this.formErrors['name'] = this.validationMessages['name']['unique'];
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/project-data-form/project-data-form.component.ts